import { api } from './client';

export type BackendNotificationStatus = 'SENT' | 'FAILED';

export type BackendNotificationType =
  | 'DISBURSE_SUCCESS'
  | 'DISBURSE_FAILED'
  | 'LOAN_APPROVED'
  | 'LOAN_REJECTED'
  | 'LOAN_NEED_MORE_INFO'
  | 'DEBT_DUE'
  | 'DEBT_OVERDUE'
  | 'DEBT_REMINDER'
  | 'HARVEST_UPDATE'
  | 'GENERAL';

export interface BackendNotification {
  _id: string;
  userId: string;
  farmerId?: string;
  channel: string;
  templateCode: string;
  notificationType: BackendNotificationType;
  title?: string;
  renderedBody: string;
  status: BackendNotificationStatus;
  isRead: boolean;
  payload: Record<string, unknown>;
  createdAt: string;
}

export async function listMyNotifications(): Promise<BackendNotification[]> {
  return api.get<BackendNotification[]>('/notifications/me');
}

export async function getUnreadNotificationCount(): Promise<{ count: number }> {
  return api.get<{ count: number }>('/notifications/me/unread-count');
}

export async function markNotificationRead(id: string): Promise<BackendNotification> {
  return api.post<BackendNotification>(`/notifications/${id}/read`);
}

export async function markAllNotificationsRead(): Promise<void> {
  return api.post<void>('/notifications/read-all');
}
